import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = ["title", "onClick"];
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "label-left" }, [
    /*#__PURE__*/ _createElementVNode("div"),
    /*#__PURE__*/ _createElementVNode("div", { class: "tab-highlight" })
], -1);
const _hoisted_3 = { class: "label-center" };
const _hoisted_4 = { class: "label-ellipsis" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "tab-highlight" }, null, -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "label-right" }, [
    /*#__PURE__*/ _createElementVNode("div"),
    /*#__PURE__*/ _createElementVNode("div", { class: "tab-highlight" })
], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", {
            class: _normalizeClass(["material-design-tabs", _ctx.size])
        }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: tab.id,
                    title: tab.label,
                    class: _normalizeClass(['tab', 'h-100', { active: _ctx.isActive(tab.id) }]),
                    onClick: ($event) => (_ctx.activateTab(tab.id))
                }, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", null, _toDisplayString(tab.label), 1)
                        ]),
                        _hoisted_5
                    ]),
                    _hoisted_6
                ], 10, _hoisted_1));
            }), 128))
        ], 2),
        _renderSlot(_ctx.$slots, "default", {
            isActive: _ctx.isActive,
            registerTab: _ctx.registerTab,
            tab: _ctx.tabMethods
        })
    ], 64));
}
